import React, { useMemo } from "react";
import { Doughnut, defaults } from "react-chartjs-2";

// HOOKS
import useColors from "../../hooks/useColors";

defaults.global.defaultFontSize = 16;

function ChartJobStatus({ count }) {
  const options = {
    title: {
      display: true,
      text: "Job Status",
      fontSize: 20,
    },
    legend: {
      display: true,
      position: "top",
    },
  };

  const data = useMemo(() => {
    delete count?.UNKNOWN;
    delete count?.ALL;
    const newData = Object.keys(count).map((key) => {
      return count[key];
    });

    return {
      labels: [
        "รับคำร้อง",
        "ติดต่อบุคคลอ้างอิง",
        "รออนุมัติ",
        "คำขอที่ถูกตีกลับ",
        "อนุมัติ",
        "ไม่ผ่านเกณฑ์",
        "อยู่ระหว่างโอนเงินให้ลูกค้า",
        "คำขอที่สมบูรณ์",
        "สิ้นสุด",
      ],
      datasets: [
        {
          label: "Job Status",
          data: newData,
          backgroundColor: [
            "rgb(230, 230, 230)", // purpule
            "rgb(255,140,0)",
            "rgb(240, 240, 0)",
            "rgb(236, 72, 153)",
            "rgb(8, 235, 8)",
            "rgb(239, 68, 68)",
            "rgb(200, 130, 200)",
            "rgb(0, 180, 0)",
            "rgb(82, 82, 91)",
          ],
          hoverOffset: 4,
        },
      ],
    };
  }, []);

  return (
    <div className="w-full md:p-5 md:mx-4">
      <Doughnut data={data} options={options} />
    </div>
  );
}

export default ChartJobStatus;
